<template>
    <div>
        <b-navbar v-if="customer.phone || customer.email" class="p-0">
            <b-navbar-nav class="ml-auto">
                <b-nav-item v-if="customer.email" class="py-0" :href="'mailto:' + customer.email" target="_blank">
                    <font-awesome-icon icon="envelope"></font-awesome-icon>
                    {{customer.email}}
                </b-nav-item>
                <b-nav-item v-if="customer.phone" class="ml-4 mr-2 py-0" :href="'tel:' + customer.phone">
                    <font-awesome-icon icon="phone"></font-awesome-icon>
                    {{customer.phone}}
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
        <b-navbar toggleable="md" variant="primary" type="dark">
            <b-navbar-brand :to="{ name: 'PortalPublication' }" class="p-0">
                <b-img v-if="logo !== ''" :src="logo" style="max-height: 56px;" alt="Logo"></b-img>
                <template v-else>{{customer.name}}</template>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item :to="{ name: 'PortalPublication' }" :active="$route.name === 'PortalPublication'">Publicaciones</b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item :to="{ name: 'PortalProfile' }" :active="true">
                        <font-awesome-icon icon="user-circle"></font-awesome-icon> {{user.name}}
                        <span class="mr-2 d-none d-md-inline"></span>
                    </b-nav-item>
                    <b-nav-item :href="PORTAL_DOCS" target="_blank" :active="true" v-b-tooltip.hover.bottom title="Ayuda">
                        <span class="ml-2 d-none d-md-inline"></span>
                        <font-awesome-icon icon="question-circle"></font-awesome-icon> <span class="d-inline d-md-none">Ayuda</span>
                    </b-nav-item>
                    <b-nav-item @click="logOut" :active="true" v-b-tooltip.hover.bottom title="Cerrar sesión">
                        <span class="ml-2 d-none d-md-inline"></span>
                        <font-awesome-icon icon="sign-out-alt"></font-awesome-icon> <span class="d-inline d-md-none">Cerrar sesión</span>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <router-view :settings="settings" :application="application" :dateRangeFormat="dateRangeFormat" @user-data-change="updateUserData"></router-view>
    </div>
</template>

<script>

import { logOutUrl, clientTokenUrl, settingUrl, bannerUrl } from '@routes';
import * as constants from '@/js/constants';

export default {
    data() {
        return {
            actionsAvailable: true,
            logo: '',
            customer: {
                id: 0,
                hash: '',
                name: '',
                phone: '',
                email: ''
            },
            user: {
                id: 0,
                name: ''
            },
            application: '',
            settings: {
                id: 0,
                theme: {
                    variant: 'light'
                },
                customFields: [
                    { id: 0, name: '', enabled: false, field: 'F1', type: 'TEXT', required: false },
                    { id: 0, name: '', enabled: false, field: 'F2', type: 'TEXT', required: false },
                    { id: 0, name: '', enabled: false, field: 'F3', type: 'TEXT', required: false },
                    { id: 0, name: '', enabled: false, field: 'F4', type: 'TEXT', required: false },
                    { id: 0, name: '', enabled: false, field: 'F5', type: 'TEXT', required: false }
                ],
                dateFormat: {
                    first: 'yyyy',
                    second: 'MM',
                    third: 'dd',
                    separator: '-'
                }
            }
        }
    },
    created() {
        let user = JSON.parse(localStorage.getItem('userInfo'));

        if (user) {
            this.user.id = user.id;
            this.user.name = user.name;
        }

        this.application = localStorage.getItem('application');

        this.loadData();
        this.loadBanner();
    },
    mounted() {
        let $this = this;

        function requestPermission() {
            // console.log('Requesting permission...');
            Notification.requestPermission().then(permission => {
                if (permission === 'granted') {
                    // console.log('Notification permission granted.');
                    resetUI();
                } else {
                    // console.log('Unable to get permission to notify.');
                }
            });
        }

        messaging.onTokenRefresh(() => {
            messaging.getToken().then(refreshedToken => {
                // console.log('Token refreshed.');

                localStorage.setItem('clientToken', refreshedToken);
                $this.axios.post(clientTokenUrl(), { token: refreshedToken });
                resetUI();
            }).catch(err => {
                // console.log('Unable to retrieve refreshed token.', err);
            });
        });

        function resetUI() {
            messaging.getToken().then(currentToken => {
                if (currentToken) {
                    localStorage.setItem('clientToken', currentToken);
                    $this.axios.post(clientTokenUrl(), { token: currentToken });
                } else {
                    // console.log('No Instance ID token available. Request permission to generate one.');
                }
            }).catch(err => {
                // console.log('An error occurred while retrieving token.', err);
            });
        }

        requestPermission();

        messaging.onMessage(payload => {
            this.$root.$bvToast.toast(payload.notification.body, {
                title: payload.notification.title,
                variant: 'info'
            });
        });
    },
    methods: {
        loadData() {
            return new Promise(resolve => {
                this.axios.get(settingUrl()).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        let settings = response.data.settings;
                        let membership = response.data.membership;

                        this.settings.id = settings.id ?? 0;

                        this.settings.dateFormat.first = settings.dateFormat.first ?? 'yyyy';
                        this.settings.dateFormat.second = settings.dateFormat.second ?? 'MM';
                        this.settings.dateFormat.third = settings.dateFormat.third ?? 'dd';
                        this.settings.dateFormat.separator = settings.dateFormat.separator ?? '-';

                        this.customer.id = membership.id;
                        this.customer.name = this.capitalize(membership.name);
                        this.customer.email = membership.contactEmail;
                        this.customer.phone = membership.contactPhone;

                        this.logo = membership.logo;

                        for (let field of settings.customFields) {
                            let customField = this.settings.customFields.find(customField => customField.field === field.field);

                            if (customField) {
                                customField.id = field.id;
                                customField.name = field.name;
                                customField.enabled = field.enabled;
                                customField.field = field.field;
                                customField.type = field.type;
                                customField.required = field.required;
                            }
                        }
                    }
                }).catch(() => {

                }).finally(resolve);
            });
        },
        loadBanner() {
            this.axios.get(bannerUrl()).then(response => {
                this.banner = response.data.message;
                this.actionsAvailable = response.data.actionsAvailable;

                let date = new Date();

                localStorage.setItem('bannerDate', `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`);
            });
        },
        updateUserData(user) {
            this.user.id = user.id;
            this.user.name = user.name;
        },
        logOut() {
            this.axios.delete(logOutUrl(), {
                data: { clientToken: localStorage.getItem('clientToken') }
            }).finally(() => {
                localStorage.removeItem('userInfo');
                localStorage.removeItem('userSettings');
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('clientId');
                localStorage.removeItem('clientSecret');
                localStorage.removeItem('application');
                localStorage.removeItem('clientToken');
                localStorage.removeItem('bannerDate');

                this.customer = {
                    id: 0,
                    hash: '',
                    name: '',
                    phone: '',
                    email: ''
                };

                this.user = {
                    id: 0,
                    name: '',
                    email: '',
                    roles: ''
                };

                this.$router.replace({ name: 'PortalLogin', params: { memberName: this.$route.params.memberName }});
            });
        },
        capitalize(value) {
            if (!value) {
                return '';
            }

            value.toString();

            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    computed: {
        dateFormat() {
            let format = this.settings.dateFormat;
            let separator = format.separator;

            return `${format.first}${separator}${format.second}${separator}${format.third}`;
        },
        dateRangeFormat() {
            let format = this.settings.dateFormat;
            let separator = format.separator;

            let map = new Map([
                ['d', 'd'],
                ['dd', 'dd'],
                ['M', 'm'],
                ['MM', 'mm'],
                ['MMM', 'mmm'],
                ['MMMM', 'mmmm'],
                ['yy', 'yy'],
                ['yyyy', 'yyyy']
            ]);

            return `${map.get(format.first)}${separator}${map.get(format.second)}${separator}${map.get(format.third)}`;
        },
        PORTAL_DOCS() {
            return constants.PORTAL_DOCS;
        }
    }
}
</script>

<style>

</style>